import axios from "axios";
import requestArticleMetadata from "../meta-api/article-meta";
import { filterRelevance } from "../meta-api/format";
import Service from "../service";
class BrandsafetyService extends Service {
    constructor(config, context) {
        super("brandsafety", context);
        this.configuration = config;
        this.apiConfiguration = {
            endpoint: "https://app-conf.almamedia.net/conf.json",
            refetch: 600000,
            timeout: 2000,
        };
        this.axiosInstance = axios.create();
    }
    async initBrandsafety() {
        if (this.configuration.ads?.enabled || this.configuration.dmp?.enabled) {
            this.logger.logInfo(`Enabled for: ${this.bsEnabled("ads") ? "ads" : ""} ${this.bsEnabled("dmp") ? "dmp" : ""}`);
            // Initial fetch (maybe not needed...)
            this.storage = await this.fetchSemantics();
        }
    }
    bsEnabled(source) {
        return (!!this.configuration[source] && !!this.configuration[source]?.enabled);
    }
    async isSafe(source) {
        this.logger.logInfo(`brand safety config ${JSON.stringify(this.configuration, null, 2)}`);
        if (!this.bsEnabled(source)) {
            this.logger.logInfo(`brand safety inactive for ${source}`);
            return undefined;
        }
        const dl = this.context.services.dataLayerService?.dataLayer;
        const pageId = dl?.pageId;
        const cid = dl?.cid;
        const unSafeList = await this.getSemantics();
        // Save some milliseconds in case no information is available
        if (unSafeList?.articleIds?.length === 0 &&
            unSafeList.rawSemantics?.length === 0) {
            this.logger.logInfo(`Brand safety information not available - Article is safe`);
            return true;
        }
        // Check article id
        this.logger.logInfo(`Unsafe article ids: ${unSafeList?.articleIds}`);
        this.logger.logInfo(`Article id: ${pageId}`);
        if (pageId && unSafeList?.articleIds?.includes(pageId.toString())) {
            this.logger.logInfo(`Brand safety for ${source} due article id ${pageId}`);
            return false;
        }
        // Check semantics for article
        if (cid) {
            try {
                this.logger.logInfo(`Requesting metadata for article ${cid}`);
                const meta = await requestArticleMetadata(this.context);
                if (meta && meta.leikiHighDef) {
                    const minFilter = this.configuration[source]?.rawSemanticsMin ?? 1;
                    const maxFilter = this.configuration[source]?.rawSemanticsMax ?? 100;
                    const articleSemantics = filterRelevance(meta.leikiHighDef, minFilter, maxFilter);
                    const lowerCaseSemantics = articleSemantics.map((v) => v.toLowerCase());
                    this.logger.logInfo(`Unsafe semantics: ${unSafeList?.rawSemantics}`);
                    this.logger.logInfo(`Article semantics: ${lowerCaseSemantics}`);
                    const isUnSafe = unSafeList && unSafeList.rawSemantics
                        ? unSafeList.rawSemantics.some((e) => lowerCaseSemantics.includes(e.toLocaleLowerCase()))
                        : false;
                    if (isUnSafe) {
                        this.logger.logInfo(`Brand safety for ${source} due semantics ${pageId}`);
                        return !isUnSafe;
                    }
                }
                else {
                    this.logger.logInfo(`Unable to get metadata for article ${pageId}`);
                }
            }
            catch (e) {
                this.logger.logError(`Unable to get meta data: ${e}`);
                return true;
            }
        }
        else {
            this.logger.logInfo(`No cid for meta data check`);
        }
        this.logger.logInfo(`Article is safe`);
        return true;
    }
    async getSemantics() {
        if (this.storage?.collected === undefined ||
            this.storage.collected + this.apiConfiguration.refetch < Date.now()) {
            this.storage = await this.fetchSemantics();
            // TODO: what to do when config is not available, safe / unsafe?
        }
        return this.storage;
    }
    async fetchSemantics() {
        this.logger.logInfo(`Fetching brand safety settings`);
        let bsGlobalConfig;
        try {
            const res = await this.axiosInstance.get(this.apiConfiguration.endpoint);
            bsGlobalConfig = {
                rawSemantics: res.data.brandsafety?.semantics ?? [],
                articleIds: res.data.brandsafety?.articleIds ?? [],
                collected: Date.now(),
            };
            this.logger.logInfo(`Brand safety settings ${JSON.stringify(bsGlobalConfig, null, 2)}`);
            return bsGlobalConfig;
        }
        catch (e) {
            this.logger.logError(e);
            return bsGlobalConfig;
        }
    }
}
export default BrandsafetyService;
//# sourceMappingURL=almabrandsafety.js.map